module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance@2x-7296b5b5d9d291550f28f56c42ecb3e9.jpg";